export default __webpack_public_path__ + "media/images/images/raty/star-off-2-6fdc47c656615e30acffa5d6b991bfc2.png";